import { Link } from "react-router-dom";
import type { Clip } from "@/mocks/clips";
import { formatViews } from "@/utils/format";

type ClipCardProps = {
  clip: Clip;
  rank?: number;
};

export default function ClipCard({ clip, rank }: ClipCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300">
      <Link to={`/clip/${clip.id}`} className="relative block h-[180px] md:h-[200px] w-full overflow-hidden" aria-label={clip.title}>
        <img
          src={clip.cover}
          alt={`${clip.title} 爆料直播片段封面`}
          title={`${clip.title} - 爆料直播高能片段`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-label text-background-50">
          <span className="bolao-live-dot inline-block h-1.5 w-1.5 rounded-full bg-background-50" />
          {clip.duration}
        </span>
        {typeof rank === "number" && (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-sm font-label font-bold text-foreground-950">
            {rank}
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-xs font-label text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{clip.host}</span>
          <span>{clip.date}</span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/clip/${clip.id}`} className="transition-colors hover:text-primary-600">
            {clip.title}
          </Link>
        </h3>
        <p className="line-clamp-2 font-body text-xs md:text-sm leading-relaxed text-foreground-600">
          {clip.summary}
        </p>
        <div className="mt-auto flex items-center gap-3 pt-2 text-xs font-label text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-play-circle-line" />
            {formatViews(clip.views)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {formatViews(clip.comments)}
          </span>
        </div>
      </div>
    </article>
  );
}